import React from "react";
import { Spinner } from "react-bootstrap";
import styles from "./Button.module.scss";

export const PrimaryButton = ({
  type = "button",
  className = "",
  onClick = () => {},
  label,
  children,
  spinner = false,
  disabled = false,
}) => {
  return (
    <button
      type={type}
      className={`${styles.customButton} ${className}`}
      onClick={onClick}
      disabled={disabled || spinner}
    >
      {spinner ? (
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
        />
      ) : (
        label || children
      )}
    </button>
  );
};

export const CancelButton = ({
    type = "button",
    className = "",
    onClick = () => {},
    label,
    children,
    disabled = false,
  }) => {
    return (
      <button
        type={type}
        className={`${styles.cancelButton} ${className}`}
        onClick={onClick}
        disabled={disabled}
      >
          {label || children}
      </button>
    );
  };